// extracted by mini-css-extract-plugin
export default {"Practice":"Practice_Practice__1zcWF","Practice__title":"Practice_Practice__title__5FZ-J","Practice__maps":"Practice_Practice__maps__ZmbhD"};